export const createHTML = (data) => {
    const template = `
    <div>
        <h4 style="margin-bottom: 5px;"> Support Request </h4>
        <div style="border: 1px solid #ddd; padding: 20px;">
            <div style="margin-bottom: 2px;">
                <span>Country: </span> <span style="font-weight: bold;"> ${data.subdomain} </span>
            </div>
            <div style="margin-bottom: 2px;">
                <span>Name: </span> <span style="font-weight: bold;"> ${
                    data.Name
                } </span>
            </div>
            <div style="margin-bottom: 2px;">
                <span>Mobile: </span> <span style="font-weight: bold;"> +${
                    data.Number
                } </span>
            </div>
            <div style="margin-bottom: 2px;">
                <span>Email: </span> <span style="font-weight: bold;"> ${
                    data.Email
                }</span>
            </div>
            <div style="margin-bottom: 2px;">
                <span>Message: </span> <span style="font-weight: bold;"> ${
                    data.Message
                } </span>
            </div>
        </div>
    </div>
    `;
    return template;
};


// WEBPACK FOOTER //
// ./src/utils/contact.js